import './style.scss';
import { useEffect, useState } from 'react';
import { platforms } from '../../common/constant';
import { Button, Divider, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from "react-redux";
import { clearProjectState, setProjectType } from '../../store/projectSlice';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import FullScreenPopup from "../../components/popup/fullScreenPopup";
import { clearSession, createSession } from '../../App'
import { validateJiraUser } from '../../services/jira.service';
import { getUserSession } from '../../services/user.service';
import { setUserJiraSession, setUserOpSession } from '../../store/userSlice';
import { setRefreshTokenTiming } from '../../store/trackingSlice';
import moment from 'moment';
import WayMoreProjectLoginComponent from '../../components/openProjectLoginUi/loginComponent';
import JiraLoginComponent from '../../components/JiraLoginUi/jiraLoginComponent';
import { checkAndUpdateUserToken } from '../../utils/auth';
import { RootState } from '../../store/store';

const LoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userState = useSelector((state: RootState) => state.user);
  const { jiraDetails, openProjectDetails, isRefresh } = userState?.user ?? {};
  const [staySigned, setStaySigned] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isAlreadyLoggedIn, setIsAlreadyLoggedIn] = useState(false);
  const [isLoggingIn, setIsLoggingIn] = useState<boolean>(false);
  const [hasNoTokensAndUserDeatils, setHasNoTokensAndUserDeatils] = useState<boolean>(false);
  const initialValues = {
    email: '',
    token: ''
  };
  const opSessionId = localStorage.getItem('opSessionId');
  const jiraSessionId = localStorage.getItem('jiraSessionId');

  useEffect(() => {
    const openProjectAccessToken = localStorage.getItem(
      "openProjectAccessToken"
    );
    const jiraAccessToken = localStorage.getItem("jiraAccessToken");
    setHasNoTokensAndUserDeatils(!(openProjectAccessToken || jiraAccessToken));
  }, [jiraDetails?.accountId, openProjectDetails?.id, isRefresh]);

  const handleRerender = () => {
    const openProjectAccessToken = localStorage.getItem(
      "openProjectAccessToken"
    );
    const jiraAccessToken = localStorage.getItem("jiraAccessToken");
    setHasNoTokensAndUserDeatils(!(openProjectAccessToken || jiraAccessToken));
  };

  useEffect(() => {
    dispatch(clearProjectState());
    // dispatch(clearTrackingSlice())
    // let jiraRefreshIntervalId: NodeJS.Timer;


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const separateUserNameFromEmail = (email: string) => {
    return email.split('@')[0];
  };

  const handleLogin = async () => {
    setIsLoggingIn(true);
    const isUserTokenValid = await checkAndUpdateUserToken();
    if (!isUserTokenValid) {
      setIsLoggingIn(false);
      sessionStorage.clear();
      navigate("/notFound");
      return;
    }
    const openProjectLoginDetails = localStorage.getItem('openProjectLoginDetails') ? JSON.parse(localStorage.getItem('openProjectLoginDetails') || '') : '';
    const jiraLoginDetails = localStorage.getItem('jiraLoginDetails') ? JSON.parse(localStorage.getItem('jiraLoginDetails') || '') : '';
    const user = sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user') || '') : '';

    if (jiraLoginDetails) {
      if (user?.email_address && jiraLoginDetails?.userDetails?.emailAddress && (separateUserNameFromEmail(user.email_address) !== separateUserNameFromEmail(jiraLoginDetails.userDetails.emailAddress))) {
        toast.error(`Logged-in Jira Email doesn't match with the previous one`);
        setIsLoggingIn(false);
        return;
      }
    }

    if (openProjectLoginDetails) {
      if (user?.email_address && openProjectLoginDetails?.userDetails?.email && (separateUserNameFromEmail(user.email_address) !== separateUserNameFromEmail(openProjectLoginDetails.userDetails.email))) {
        toast.error(`Logged-in Open project Email doesn't match with the previous one`);
        setIsLoggingIn(false);
        return;
      }
    }

    const openProjectAccessToken = localStorage.getItem('openProjectAccessToken');
    const jiraAccessToken = localStorage.getItem('jiraAccessToken');

    if (jiraAccessToken && !openProjectAccessToken) {
      dispatch(setProjectType('Jira'))
    }

    if (openProjectAccessToken || jiraAccessToken) {

      const [opSessionDetails, jiraSessionDetails] = await Promise.all([
        getUserSession(openProjectLoginDetails?.userDetails?.email, platforms.OPEN_PROJECT),
        getUserSession(jiraLoginDetails?.userDetails?.emailAddress, platforms.JIRA),
      ]);

      if (opSessionDetails?.statusCode === 200 && jiraSessionDetails?.statusCode === 200) {
        if (!opSessionDetails?.data?.id && !jiraSessionDetails?.data?.id) {
          localStorage.removeItem("opSessionId");
          localStorage.removeItem("jiraSessionId");
          setIsAuthenticated(true);
          dispatch(setRefreshTokenTiming([moment(new Date()).format('YYYY-mm-dd HH:mm:ss')]));

          const sessionDetails = await createSession();
          if (sessionDetails.opSessionId) {
            dispatch(setUserOpSession(sessionDetails.opSessionId));
          }
          if (sessionDetails.jiraSessionId) {
            dispatch(setUserJiraSession(sessionDetails.jiraSessionId));
          }
          if (!staySigned) {
            goHome();
          }
        } else {
          if (opSessionDetails?.data?.id) {
            localStorage.setItem("opSessionId", opSessionDetails.data.id);
          }
          if (jiraSessionDetails?.data?.id) {
            localStorage.setItem("jiraSessionId", jiraSessionDetails.data.id);
          }
          setIsAlreadyLoggedIn(true);
        }
      } else {
        toast.error('Error in while fetching user sessions, please try again later');
      }
    } else toast.error('Invalid Login');
    setIsLoggingIn(false);
  };

  const validationSchema = Yup.object({
    email: Yup.string().matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      'Invalid email format').required('Email is required'),
    token: Yup.string().required('Token is required')
  });

  const onSubmit = async (values: typeof initialValues) => {
    setLoader(() => true);
    try {
      const userDetails = await validateJiraUser(values.email, values.token);
      if (userDetails?.data?.accountId) {
        goHome();
      } else {
        toast.error('Provided credential is invalid, skip this step or try with valid credentials');
      }
    } catch {
      toast.error('Provided credential is invalid, skip this step or try with valid credentials');
    } finally {
      setLoader(() => false);
    }
  };

  const goHome = () => {
    navigate('/deprecated/home');
    toast.success('Login Success');
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  });

  const getSessionName = (): string | null => {
    if (opSessionId) return "OpenProject";
    if (jiraSessionId) return "Jira";
    if (jiraSessionId && opSessionId) return "Jira and OpenProject";
    return "PMS";
  };

  const sessionName = getSessionName();

  if (isAlreadyLoggedIn) {
    return <FullScreenPopup isOpen={isAlreadyLoggedIn}>
      You already have an active session in <strong>{sessionName}</strong>
      Would you like to log out from the previous session?
      <Button variant="contained" color="info" sx={{ textTransform: 'none' }}
        onClick={() => {
          setIsAlreadyLoggedIn(false);
          clearSession()
        }
        }>
        Logout
      </Button>
    </FullScreenPopup>
  }


  return (
    <div className="loginOuterDiv">

      {
        isAuthenticated && staySigned ? <>
          <form onSubmit={formik.handleSubmit} className='validateUserForm'>
            <span style={{ fontSize: 'xx-large', fontWeight: '100' }}>Stay signed</span>
            <TextField
              size="small"
              label="Email"
              type="text"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
              fullWidth
              margin="normal"
            />
            <TextField
              size="small"
              label="Token"
              type="password"
              name="token"
              value={formik.values.token}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.token && Boolean(formik.errors.token)}
              helperText={formik.touched.token && formik.errors.token}
              fullWidth
              margin="normal"
            />
            <Button type='submit' variant='contained' className='buttonWidth' disabled={loader || !formik.dirty || !formik.isValid}>Validate
              {loader && <CircularProgress size={20} style={{ marginLeft: '10px' }} />}
            </Button>
          </form>
        </> : <>
          <span style={{ fontSize: 'xxx-large', fontWeight: '100' }}>Login</span>

          <WayMoreProjectLoginComponent handleRerender={handleRerender}/>


          {/* <iframe className="iframeStyle"
            ref={openProjectRef}
            src={OPEN_PROJECT_OAUTH_IFRAME}
            title="Executive summary Open project login"
            height="50px"
            onLoad={sentMessageToOpenProject}
          ></iframe> */}


          <Divider sx={{ height: 2, width: '70%', alignItems: 'center' }}>or continue with</Divider>

          <JiraLoginComponent handleRerender={handleRerender}/>

          {/* <iframe className="iframeStyle"
            ref={jiraRef}
            src={JIRA_OAUTH_IFRAME}
            title="Executive summary Jira login"
            height="50px"
            onLoad={sentMessageToJira}
          ></iframe> */}

          {/* <FormControlLabel
              control={
                <Checkbox
                  name="staySigned"
                  checked={staySigned}
                  onChange={handleCheckboxChange}
                  size="small"
                />
              }
              label="Stay signed"
            /> */}
          <Button
            // PMS Web UI is deprecated — login is disabled.
            // disabled={isLoggingIn || hasNoTokensAndUserDeatils}
            disabled
            variant="contained"
            className="textWidth"
            onClick={handleLogin}
            sx={{
              textTransform: "none",
              backgroundColor: " #43425d",
              fontFamily: "Inter, Helvetica Neue, Helvetica, Arial, sans-serif",
              fontSize: "500",
            }}
          >
            Login
          </Button>
        </>
      }
    </div>
  )
}

export default LoginPage
